export default "__VITE_ASSET__Ck9W34Yb__"